import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { messages } from '../../funciones/mensajes';
import { ExcelService } from '../../../services/excel/excel.service';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { obtenerError, procesamiento } from '../../../models/Formulacion/indicadores-metas/datos';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { InstitucionService } from '../../../services/gestion/institucion/institucion.service';
import { PERMISOS } from '../../../shared/catalogos';

@Component({
  selector: 'app-catalogos',
  templateUrl: './catalogos.component.html',
  styleUrl: './catalogos.component.css'
})
export class CatalogosComponent implements OnInit {
  public readonly permisos = PERMISOS;
  private idInstitucion: Number;

  public responsables = [];
  public responsableEdicion = [];
  public idArea;
  public mostabla: boolean = false; //Controlar visibilidad de la tabla
  public loadingInfo: boolean = true;
  public templatesGenerales = [];
  public templatesActas = [];
  public templatesGeneralesOrden = ['Indicadores', 'Tareas de proyectos', 'Reportes seguimiento'];
  public templatesActasOrden = ['Validación de cumplimiento de actividad', 'Tareas de actas', 'Envio de acta al equipo'];
  public templatesInstitucion = [];
  public cambios = [];
  public realizoCambios = false;
  public siVeActas = false;
  private html;

  agrgearRes = false;
  editarRes = false;

  public logOutAct = false;
  public logOutTime = 5;
  private logOutActInst = false;
  private logOutTimeInst = 5;
  private idSettings;
  private institutionCode = '';

  public urll = '';
  public bufferArray = [];

  public formNuevo = new FormGroup({
    nombre: new FormControl('', [Validators.required]),
    primerApellido: new FormControl('', [Validators.required]),
    segundoApellido: new FormControl('', []),
    correo: new FormControl('', [Validators.required, Validators.email]),
    puestoCargo: new FormControl('', [Validators.required]),
  }, { validators: this.nombreDuplicidad() });

  public formEditar = new FormGroup({
    nombre: new FormControl('', [Validators.required]),
    primerApellido: new FormControl('', [Validators.required]),
    segundoApellido: new FormControl('', []),
    correo: new FormControl('', [Validators.required, Validators.email]),
    puestoCargo: new FormControl('', [Validators.required]),
  }, { validators: this.nombreDuplicidad() });

  constructor(
    public dataService: DataService,
    public translate: TranslateService,
    // private catalogoService: CatalogosService,
    private excelService: ExcelService,
    private cookieService: CookieService,

    private intitutionService: InstitucionService,
    private responsableService: ResponsableService,
  ) {
    this.siVeActas = dataService.veActas;
    this.loadingInfo = true;
    this.obtData();
  }

  ngOnInit(): void { }

  private async obtData() {
    try {
      // Obtener áreas
      this.idInstitucion = Number(this.cookieService.get('idInstitucion'));
      const areas = await firstValueFrom(this.responsableService.getResponsable());
      this.responsables = [];
      this.responsables = areas.filter(a => Number(a.institution.id) === Number(this.idInstitucion) && a.responsibles.length !== 0 );
      // Obtener institución
      const institution = await this.intitutionService.getInstitucion(this.idInstitucion);
      if (institution) {
        if (institution.settings.length === 0) {
          await firstValueFrom(this.intitutionService.postSettings(this.idInstitucion));
          this.obtData();
          return;
        } else {
          this.logOutAct = institution.settings[0]['name'] === 'false' ? false : true;
          this.logOutActInst = institution.settings[0]['name'] === 'false' ? false : true;
          this.logOutTime = Number(institution.settings[0]['value']);
          this.logOutTimeInst = Number(institution.settings[0]['value']);
          this.idSettings = institution.settings[0]['id'];
          this.templatesInstitucion = [];
          for (const tem of institution.templates) {
            this.templatesInstitucion.push(tem.id);
          }

          // Obtener templates
          const templates = await this.intitutionService.getTemplates();
          this.obtTemplates(templates);
        }

        this.institutionCode = institution.code;

         // Obtener archivos
        try {
          const archivos = await firstValueFrom(this.intitutionService.getArchivosAdm(this.institutionCode));
          for (const doc of archivos) {
            const name = ('' + doc['filename']).split('.');
            const nomsep = name[0].split('_');
            for (const nam of nomsep) {
              if (nam.toLocaleLowerCase() === 'logo') {
                try {
                  const archivoData = await firstValueFrom(this.intitutionService.getArchivosA(doc._id));
                  var base = 'data:image/' + name[name.length - 1] + ';base64,' + btoa(new Uint8Array(archivoData).reduce((data, byte) => data + String.fromCharCode(byte), ''));
                  this.urll = base;
                  this.bufferArray = [{ buffer: archivoData, tipo: name[name.length - 1] }];
                } catch (err) {
                  messages.errorMessageGraph(err);
                }
                break;
              }
            }
          }
        } catch (err) {
          messages.errorMessageGraph(err);
        }
      }
      this.mostabla = true; //Mostrar tabla cuando los datos están listos
      this.loadingInfo = false; //Desactivar skeleton loader de información
    } catch (error) {
      messages.errorMessageGraph(error.message);
    }
  }

  /** Obtener datos */
  public obtResponsable(res: any) {
    let responsable = res.name + ' ' + res.first_surname + ' ' + res.second_surname;
    return responsable;
  }
  public obtCorreo(res: any) {
    let correo = res.email + ' ';
    return correo;
  }

  private obtTemplates(response: any) {
    const Gen = response.filter(tem => tem.name === 'Tareas de proyectos' || tem.name === 'Indicadores' || tem.name === 'Reportes seguimiento');
    const Act = response.filter(tem => tem.name === 'Tareas de actas' || tem.name === 'Validación de cumplimiento de actividad' || tem.name === 'Envio de acta al equipo');
    this.templatesGenerales = [];
    this.templatesActas = [];
    for (const tem of this.templatesGeneralesOrden) {
      const aux = Gen.filter(t => t.name === tem);
      this.templatesGenerales.push({
        id: aux[0].id,
        name: aux[0].name,
        check: this.existeTemplate(aux[0].id),
      });
    }
    for (const tem of this.templatesActasOrden) {
      const aux = Act.filter(t => t.name === tem);
      this.templatesActas.push({
        id: aux[0].id,
        name: aux[0].name,
        check: this.existeTemplate(aux[0].id),
      });
    }
  }

  /* Validador */
  public async cambioValidator(res) {
    try {
      res.isValidator = !res.isValidator;
      await firstValueFrom(this.responsableService.patchResponsableValidador(res));
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'))
    } catch (error) {
      messages.errorMessageGraph(error.message);
    }
  }


  /** Modales */
  public abrirAgregarRes() {
    this.agrgearRes = true;
  }

  public abrirEditarRes(res: any, areaId: any) {
    this.responsableEdicion = res;
    this.idArea = areaId;
    this.formEditar.controls['nombre'].setValue(res.name);
    this.formEditar.controls['primerApellido'].setValue(res.first_surname !== ' ' ? res.first_surname : '');
    this.formEditar.controls['segundoApellido'].setValue(res.second_surname !== ' ' ? res.second_surname : '');
    this.formEditar.controls['correo'].setValue(res.email);
    this.formEditar.controls['puestoCargo'].setValue(res.position);
    this.editarRes = true;
  }


  public cerrarFormulario() {
    this.agrgearRes = false;
    this.editarRes = false;
    this.formNuevo.reset();
    this.formEditar.reset();
  }

  /** Mecanismo de desición de guardado */
  public alertasGuardado(guardar: any) {
    switch (guardar) {
      case 'nuevo':
        if (this.formNuevo.invalid) {
          messages.errorMessageGraph(this.translate.instant('swal.ingreseInformacion'));
        } else {
          this.guardarNuevo();
        }
        break;
      case 'editar':
        if (this.formEditar.invalid) {
          Swal.fire({
            title: this.translate.instant('swal.informacionFaltante'),
            text: '',
            icon: 'error',
            showConfirmButton: false,
            timer: this.dataService.time
          });
        } else {
          this.guardarEditar();
        }
        break;
    }
  }

  public async guardarEditar() {
    try {
      const area = {
        name: this.formEditar.value.puestoCargo,
        institutionId: Number(this.idInstitucion),
        id: this.idArea,
      };

      // Actualizar área
      await firstValueFrom(this.responsableService.patchArea(area));
      const responsable = {
        name: this.formEditar.value.nombre,
        first_surname: this.formEditar.value.primerApellido,
        second_surname: this.formEditar.value.segundoApellido !== null && this.formEditar.value.segundoApellido !== '' ? this.formEditar.value.segundoApellido : ' ',
        email: this.formEditar.value.correo,
        position: this.formEditar.value.puestoCargo,
        areaId: Number(this.idArea),
        id: this.responsableEdicion['id'],
      };
      await firstValueFrom(this.responsableService.patchResponsable(responsable));
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));

      this.obtData();
      this.cerrarFormulario();
    } catch (err) {
      let er = obtenerError.errorObt(err['error']?.message || err.message);
      messages.errorMessageGraph(er);
    }
  }

  /** Guardado de datos */
  public async guardarNuevo() {
    try {
      const area = {
        name: this.formNuevo.value.puestoCargo,
        institutionId: Number(this.idInstitucion)
      };

      // Crear área
      const areaResponse = await firstValueFrom(this.responsableService.postArea(area));
      // Crear responsable
      const responsable = {
        name: this.formNuevo.value.nombre,
        first_surname: this.formNuevo.value.primerApellido,
        second_surname: this.formNuevo.value.segundoApellido !== null && this.formNuevo.value.segundoApellido !== '' ? this.formNuevo.value.segundoApellido : ' ',
        email: this.formNuevo.value.correo,
        position: this.formNuevo.value.puestoCargo,
        areaId: Number(areaResponse.id),
      };
      await firstValueFrom(this.responsableService.postResponsable(responsable));

      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      this.obtData();
      this.cerrarFormulario();
    } catch (err) {
      let er = obtenerError.errorObt(err['error']?.message || err.message);
      messages.errorMessageGraph(er);
    }

  }

  public cambioCheckBox(click) {
    click.check = !click.check;
    var normal = 0, mas = 0;
    for (const tem of this.templatesGenerales) {
      const existe = this.templatesInstitucion.filter(temp => temp === tem.id);
      if (tem.check && existe.length !== 0) {
        normal++;
      } else if (tem.check) {
        mas++;
      }
    }
    for (const tem of this.templatesActas) {
      const existe = this.templatesInstitucion.filter(temp => temp === tem.id);
      if (tem.check && existe.length !== 0) {
        normal++;
      } else if (tem.check) {
        mas++;
      }
    }

    if (normal === this.templatesInstitucion.length && mas === 0) {
      this.realizoCambios = false;
    } else {
      this.realizoCambios = true;
    }
  }

  public existeTemplate(idTemplate): boolean {
    const existe = this.templatesInstitucion.filter(tem => tem === idTemplate);
    if (existe.length !== 0) {
      return true;
    }
    return false;
  }

  public cancelarSeleccion() {
    for (const tem of this.templatesGenerales) {
      tem.check = this.existeTemplate(tem.id);
    }
    for (const tem of this.templatesActas) {
      tem.check = this.existeTemplate(tem.id);
    }
    this.realizoCambios = false;
  }

  public async guardarSeleccion() {
    try {
      this.cambios = [];
      for (const tem of this.templatesGenerales) {
        if (tem.check) {
          this.cambios.push(tem.id);
        }
      }
      for (const tem of this.templatesActas) {
        if (tem.check) {
          this.cambios.push(tem.id);
        }
      }

      await firstValueFrom(this.intitutionService.patchInstitucion(this.idInstitucion, this.cambios));
      const response = await this.intitutionService.getInstitucion(this.idInstitucion);

      if (response) {
        this.templatesInstitucion = [];
        for (const tem of response.templates) {
          this.templatesInstitucion.push(tem.id);
        }
        this.cancelarSeleccion();
        this.realizoCambios = false;
        messages.succesMessageGraph(this.translate.instant('gestion.admin.catalogos.notiActualizadas'));
      }
    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }

  /* Cambios en el log out */
  public realizoCambiosLogOut() {
    if (this.logOutAct !== this.logOutActInst || this.logOutTime !== this.logOutTimeInst) {
      return true;
    }
    return false;
  }
  public async guardarCambiosLogOut() {
    try {
      await firstValueFrom(this.intitutionService.patchSettings(this.logOutAct, this.logOutTime, this.idSettings, this.idInstitucion));
      const response = await this.intitutionService.getInstitucion(this.idInstitucion);

      this.logOutAct = response.settings[0]['name'] === 'false' ? false : true;
      this.logOutActInst = response.settings[0]['name'] === 'false' ? false : true;
      this.logOutTime = Number(response.settings[0]['value']);
      this.logOutTimeInst = Number(response.settings[0]['value']);
      this.idSettings = response.settings[0]['id'];

      Swal.fire({
        title: this.translate.instant('gestion.admin.catalogos.logOutActualizado'),
        text: '',
        icon: 'success',
        showConfirmButton: false,
        timer: this.dataService.time,
        willClose: () => {
          window.location.reload();
        }
      });
    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }
  public cancelarCambiosLogOut() {
    this.logOutAct = this.logOutActInst;
    this.logOutTime = this.logOutTimeInst;
  }


  /* modal info  */
  public modalInfo() {
    let actas = '';
    if (this.siVeActas) {
      actas = `
      <div style="text-align: justify; margin-left: 2vw; margin-right: 2vw;">
        <div style="margin-bottom: 1rem;">
          &#8226;
          <span style="font-weight: 500;">${this.translate.instant('gestion.admin.catalogos.modalInfo.actas.tareasActas.titulo')}</span> 
          ${this.translate.instant('gestion.admin.catalogos.modalInfo.actas.tareasActas.descripcion')}
        </div>
        <div style="margin-bottom: 1rem;">
          &#8226;
          <span style="font-weight: 500;">${this.translate.instant('gestion.admin.catalogos.modalInfo.actas.validacionCumplimiento.titulo')}</span> 
          ${this.translate.instant('gestion.admin.catalogos.modalInfo.actas.validacionCumplimiento.descripcion')}
        </div>
        <div style="margin-bottom: 1rem;">
          &#8226;
          <span style="font-weight: 500;">${this.translate.instant('gestion.admin.catalogos.modalInfo.actas.envioActa.titulo')}</span> 
          ${this.translate.instant('gestion.admin.catalogos.modalInfo.actas.envioActa.descripcion')}
        </div>
      </div>
    `;
    }

    this.html = `
    <div id="informacion">
      <div class="alinIzq" style="width: 35vw; text-align: justify;">
        ${this.translate.instant('gestion.admin.catalogos.modalInfo.descripcionPrincipal')}
        <br><br>
        <div style="text-align: justify; margin-left: 2vw; margin-right: 2vw;">
          <div style="margin-bottom: 1rem;">
            &#8226;
            <span style="font-weight: 500;">${this.translate.instant('gestion.admin.catalogos.modalInfo.indicadores.titulo')}</span> 
            ${this.translate.instant('gestion.admin.catalogos.modalInfo.indicadores.descripcion')}
          </div>
          <div style="margin-bottom: 1rem;">
            &#8226;
            <span style="font-weight: 500;">${this.translate.instant('gestion.admin.catalogos.modalInfo.tareasProyectos.titulo')}</span> 
            ${this.translate.instant('gestion.admin.catalogos.modalInfo.tareasProyectos.descripcion')}
          </div>
          <div style="margin-bottom: 1rem;">
            &#8226;
            <span style="font-weight: 500;">${this.translate.instant('gestion.admin.catalogos.modalInfo.reportesSeguimiento.titulo')}</span> 
            ${this.translate.instant('gestion.admin.catalogos.modalInfo.reportesSeguimiento.descripcion')}
          </div>
        </div>
        ${actas}
      </div>
    </div>
  `;

    Swal.fire({
      title: this.translate.instant('gestion.admin.catalogos.modalInfo.titulo'),
      html: this.html,
      showConfirmButton: false,
      width: 'auto',
    });
  }

  /** vizualizar imagen */
  public vizualizarImagen() {
    if (this.bufferArray.length !== 0) {
      const mediaTypei = 'image/' + this.bufferArray[0].tipo;
      const blobi = new Blob([this.bufferArray[0].buffer], { type: mediaTypei });
      const url = URL.createObjectURL(blobi);
      Swal.fire({
        imageUrl: url,
        imageAlt: this.translate.instant('gestion.admin.catalogos.altText'),
        showConfirmButton: false,
      });
    }
  }

  /** Eliminación datos */
  public async eliminarResponsable(res: any, area: any) {
    const result = await messages.confirmationSave(
      this.translate.instant('gestion.admin.catalogos.borrarResponsable'),
      this.translate.instant('gestion.admin.catalogos.responsableText'),
      this.translate
    );

    if (result) {
      if (area.indicators.length === 0) {
        try {
          await firstValueFrom(this.responsableService.deleteResponsable(res));
          await firstValueFrom(this.responsableService.deleteArea(area));

          messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));
          this.obtData();
        } catch (err) {
          let er = obtenerError.errorObt(err['error'].message);
          messages.errorMessageGraph(er);
        }
      } else {
        messages.errorMessageGraph(this.translate.instant('gestion.admin.catalogos.errorEliminar'));
      }
    }
  }

  /** Exportar excel */
  public exportarExcel() {
    let nombreAr = this.translate.instant('gestion.admin.catalogos.tituloAr');
    const title = this.translate.instant('gestion.admin.catalogos.tituloExcel');
    let head1 = this.translate.instant('gestion.admin.catalogos.head1');
    let head2 = this.translate.instant('gestion.admin.catalogos.head2');
    let head3 = this.translate.instant('gestion.admin.catalogos.head3');

    const headers = [head1, head2, head3];
    let columnas = [];
    let arreglo = [];
    for (const res of this.responsables) {
      columnas.push(res.name);
      columnas.push(res.responsibles[0].name + ' ' + res.responsibles[0].first_surname + ' ' + res.responsibles[0].second_surname);
      columnas.push(res.responsibles[0].email);
      arreglo.push(columnas);
      columnas = [];
    }
    this.excelService.generateExcelResponsables(title, headers, arreglo, nombreAr);
  }

  /** Comprobación de que el nombre no exista*/
  private nombreDuplicidad(): ValidatorFn {
    return (formGroup: FormGroup) => {
      var nombre = ""
      if (this.agrgearRes) {
        nombre = this.formNuevo.value.puestoCargo;
      } else if (this.editarRes) {
        nombre = this.formEditar.value.puestoCargo;
      }
      if (this.agrgearRes) {
        const existe = this.responsables.find(res => procesamiento.procesamiento_Texto(res.name).toLowerCase() === nombre.toLowerCase())
        if (existe) return { isValid: true };
      } else if (this.editarRes) {
        const existe = this.responsables.find(res =>
          procesamiento.procesamiento_Texto(res.name).toLowerCase() === nombre.toLowerCase() && res.id !== this.idArea
        );
        if (existe) return { isValid: true };
      }
      return null;
    };
  }

  /** validaciones de guardado */
  public puedeGuardarAgregar() {
    if (this.formNuevo.invalid) {
      return 'w3-disabled';
    }
    return '';
  }
  public puedeGuardarEditar() {
    if (this.formEditar.invalid) {
      return 'w3-disabled';
    }
    return '';
  }

  public clickFuera(event, modal) {
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      }, 600);
    }
  }

}
